import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import ScoreBar from './ScoreBar'

import subSections from '../data/subSections'

const SectionResult = ({ firstSubSection, sectionScore, section, subSectionScores }) => {
    const findSubSectionScore = (scoreNum) => {
        if (!scoreNum) {
          return {text: "", className: ""}
        } else if (scoreNum <= 50) {
          return {text: "Area for Improvement", className: "low-score"}
        } else if (scoreNum <= 75) {
          return {text: "Almost Ready", className: "medium-score"}
        } else {
          return {text: "Ready", className: "high-score"}
        }
    }

    return (
        <div className="section-result-bar grid-x grid-margin-x grid-padding-x">
            <div className="section-title cell small-12 medium-4 large-3">
                <div className={`icon ${section.secId}-icon`} dangerouslySetInnerHTML={section.icon}></div>
                <h4 className="bold">{ `${section.number}. ${section.title}` }</h4>
                    <div className="btn-group--concept-result no-print">
                    <Link to={`/question/${section.secId}/${firstSubSection}/${firstSubSection}1`} className="btn question-btn">Answer Questions</Link>
                    <Link className="btn question-btn" to={`/guidance/${section.secId}/${firstSubSection}`}>View Guidance</Link>
                </div>
            </div>
            <div className="cell small-12 medium-8 large-9">
                <div className="grid-x grid-margin-x grid-margin-y">
                    <div className="section-result cell medium-12 large-6 no-print-vertical-margin">
                        <h4>Concept result:</h4>
                        <ScoreBar score={ sectionScore }/>
                    </div>
                    { (subSectionScores[0].section != "finance") && <div className="sub-section-results cell medium-12 large-6 no-print-vertical-margin">
                        <h4>Key Component results:</h4>
                        { subSectionScores.map((subSection) => {
                            if (!!subSection.score) {
                                const result = findSubSectionScore(subSection.score)
                                const subSectionNumber = subSections.find(subSec => subSec.title === subSection.title).number
                                return (
                                    <h5 key={subSection.title}>{`${section.number}${subSectionNumber}. ${subSection.title} - `}<span className={`${result.className} bold`}>{result.text}</span></h5>
                                )
                            }
                        }) }
                    </div> }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state, props) => {
    return {
        sectionScore: state.scores.sections[props.section.secId],
    }
}

export default connect(mapStateToProps)(SectionResult)


// WEBPACK FOOTER //
// ./src/components/SectionResult.js